interface LetteredAvatarProps {
  name: string
}
export default function LetteredAvatar({ name }: LetteredAvatarProps) {
  function getInitials(name: string) {
    if (name.startsWith('@')) {
      return name.substring(1, 3).toUpperCase();
    }

    return name.substring(0, 2).toUpperCase();
  }

  function generateBackground(name:string) {
    let hash = 0;
    let i;

    for(i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    // name.charCodeAt() return an int between 0 and 65535
    // left shift (<<)  operator moves to left by number of specified 
    // bites after <<. The whole for loop will create a color hash 
    // based on username length

    let color = '#';
    for(i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }

  let initials = getInitials(name);
  let color = generateBackground(name);
  const customStyle = {
    display: 'flex',
    height: '36px',
    width: '36px',
    borderRadius: '60px',
    color: 'white',
    background: color,
    margin: 'auto'
  }

  return (
    <div style={customStyle}>
      <span style={{ margin: 'auto'}}>{initials}</span>
    </div>
  );
}